import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from 'ng2-translate';
import { CardsListComponent } from './containers/cards-list/cards-list.component';
import { CardFilterPositionDirective } from './directives/card-filter-position.directive';
import { CardItemSizeDirective } from './directives/card-item-size.directive';
import { CardListDisplayDirective } from './directives/card-list-display.directive';
import { CardListOrientationDirective } from './directives/card-list-orientation.directive';

import { CardsCategoryComponent } from './components/cards-category/cards-category.component';
import { CardsItemComponent } from './components/cards-item/cards-item.component';
import { CardListService } from './services/card-list.service';
import { EmptyStateModule } from '../empty-state/empty-state.module';

@NgModule({
    declarations: [
        CardsListComponent, CardListDisplayDirective, CardsCategoryComponent, CardsItemComponent, CardItemSizeDirective, CardListOrientationDirective, CardFilterPositionDirective
    ],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule, EmptyStateModule
    ],
    exports: [
        CardsListComponent, CardListDisplayDirective, CardsCategoryComponent, CardsItemComponent, CardItemSizeDirective, CardListOrientationDirective, CardFilterPositionDirective
    ],
    entryComponents: [CardsListComponent, CardsCategoryComponent, CardsItemComponent],

    providers: [CardListService]
})
export class CardListModule { }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/card-list.module.ts